{
  "sdk-download-android": "Скачать для Android",
  "sdk-connect": "Подключить",
  "sdk-download-ios": "Скачать для iOS",
  "sdk-install": "Установить",
  "sdk-modal-instruct-1": "1. Откройте приложение Binance",
  "sdk-modal-instruct-2": "2. Нажмите {{icon}} на главном экране",
  "sdk-modal-title": "Подключить кошелек Binance",
  "sdk-no-app": "У вас еще нет приложения Binance?"
}